// Note: The first file of a module here, must also register the module

import "./phone-login.component";
import "./auth-login.component";
import "./verification-code.component";
